<template>
  <MainLayout>
    <div class="w-100">
      <v-card class="mx-auto">
        <v-card-title>
          <v-sheet
            :elevation="4"
            class="icon--box"
          >
            <i class="fas fa-address-card" />
          </v-sheet>

          <span class="title ml-4">Anrede</span>

          <span
            v-if="createView"
            class="title font-weight-light ml-2 animate-text"
          >Erfassen</span>
          <span
            v-else-if="editView"
            class="title font-weight-light ml-2 animate-text"
          >Bearbeiten</span>
        </v-card-title>

        <v-card-text>
          <transition
            v-if="createView"
            :name="enableFade ? 'fade' : 'no-fade'"
            appear
          >
            <anreden-create />
          </transition>
          <transition
            v-else-if="editView"
            :name="enableFade ? 'fade' : 'no-fade'"
            appear
          >
            <anreden-edit />
          </transition>
          <transition
            v-else
            :name="enableFade ? 'fade-out' : 'fade'"
            appear
          >
            <anreden-overview />
          </transition>
        </v-card-text>
      </v-card>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import AnredenOverview from "@/components/UserManagement/Anreden/AnredenOverview.vue";
import AnredenCreate from "@/components/UserManagement/Anreden/AnredenCreate.vue";
import AnredenEdit from "@/components/UserManagement/Anreden/AnredenEdit.vue";

export default {
  components: {
    MainLayout,
    AnredenOverview,
    AnredenCreate,
    AnredenEdit,
  },
  data() {
    return {
      createView: false,
      editView: false,
      anredenId: null,
      enableFade: false,
    };
  },
  watch: {
    "$route.params.action"(newValue) {
      this.checkAction(newValue);
    },
  },
  mounted() {
    if (this.$route.params.action) {
      this.checkAction(this.$route.params.action);
    }

    //Wir wollen keine Animationen beim initial laden der Seite
    setTimeout(() => {
      this.enableFade = true;
    }, "1 second");
  },
  methods: {
    checkAction(action) {
      if (action === "create") {
        this.createView = true;
      } else if (action === "edit") {
        this.editView = true;
      } else {
        this.createView = false;
        this.editView = false;
      }
    },
  },
};
</script>

<style scoped>
.icon--box {
  top: -30px;
  background-color: #e72b37;
  border-radius: 4px;
  text-align: start !important;
  padding: 28px !important;
  margin-bottom: -24px !important;

  font-size: 20px;
  color: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
  overflow: hidden;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  height: 0;
  max-height: 0;
  transform: translateY(-20px);
}

.fade-leave-to {
  transform: translateY(20px);
}

.fade-out-enter-active,
.fade-out-leave-active {
  transition: all 1s ease-in-out;
  overflow: hidden;
}

.fade-out-enter,
.fade-out-leave-to {
  opacity: 0;
  height: 0;
  max-height: 0;
  transform: translateY(20px);
}

.fade-out-leave-to {
  transform: translateY(-20px);
}

.animate-text {
  animation-name: slideInFromLeft;
  animation-duration: 1s;
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
